/**
 * @module qbLinkage/detectChanges/detectRawColumnChanges
 * @description 明细模式 rawColumn 类别：增删改重排
 *
 * 仅在 prev/next 均为 mode=raw 时由 detectCategoryDelta 调度。
 * 明细 QB 操作区只有 columnRawColumns，配置项 prune 依赖本检测器产出的事件。
 */

import type { IQBSnapshot, TQBEvent } from '../types';
import { rawColumnListSignature, snapshotList } from '../fieldSnapshot';
import {
  addedFields,
  diffRenames,
  findReorder,
  removedFields,
} from './fieldDiffUtils';
import type { IPartialQBChangeSet } from './partialChangeSet';

export function detectRawColumnChanges(
  prev: IQBSnapshot,
  next: IQBSnapshot,
): IPartialQBChangeSet {
  const events: TQBEvent[] = [];
  const prevCols = snapshotList(prev.columnRawColumns ?? [], 'metric');
  const nextCols = snapshotList(next.columnRawColumns ?? [], 'metric');

  const addedRawColumns = addedFields(prevCols, nextCols);
  const removedRawColumns = removedFields(prevCols, nextCols);

  if (addedRawColumns.length) {
    events.push('rawColumnAdded');
  }
  if (removedRawColumns.length) {
    events.push('rawColumnRemoved');
  }

  const reorderedRawColumns = findReorder(prevCols, nextCols);
  if (reorderedRawColumns) {
    events.push('rawColumnReordered');
  }

  const rawRenamed = diffRenames(prevCols, nextCols);
  const renamed = [...rawRenamed];
  for (const r of rawRenamed) {
    if (r.displayOnly) {
      events.push('fieldRenamed');
    } else {
      events.push('fieldIdentityRenamed');
    }
  }

  return {
    events,
    addedRawColumns,
    removedRawColumns,
    reorderedRawColumns,
    renamed,
  };
}
